import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-live-manage",
  "use": "icon-live-manage-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-live-manage\"><defs><style type=\"text/css\"></style></defs><path d=\"M760.55134815 387.72432592l161.5583763-80.77918814c31.06891852-12.42756741 68.35162075 0 80.77918814 24.85513481 6.2137837 12.42756741 6.2137837 24.85513482 6.21378371 31.06891852v298.26161778c0 37.28270222-24.85513482 62.13783703-62.13783705 62.13783703-12.42756741 0-18.64135111 0-24.8551348-6.2137837L760.55134815 636.27567408V387.72432592zM139.17297778 201.31081482h434.96485925c68.35162075 0 124.27567408 55.92405333 124.27567408 124.27567407v372.82702222c0 68.35162075-55.92405333 124.27567408-124.27567408 124.27567407H139.17297778c-68.35162075 0-124.27567408-55.92405333-124.27567408-124.27567407V325.58648889c0-68.35162075 55.92405333-124.27567408 124.27567408-124.27567407z\" p-id=\"2354\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/live-manage.svg
// module id = e+f0
// module chunks = 101